// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpd-timeline-item::-webkit-scrollbar,.time-section::-webkit-scrollbar {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/features/Setting/Service Request/cpdStatusStyle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".cpd-timeline-item::-webkit-scrollbar,.time-section::-webkit-scrollbar {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
